import { useApiQuery } from "@/api";

type Options = {
  enabled?: boolean;
  refetchInterval?: number | false;
};

export default function useListConversations(options: Options = {}) {
  return useApiQuery(["ai_chat_list_conversations", {}], {
    staleTime: 30_000,
    ...options,
  });
}
